import React, { useState } from 'react';
import {
  Box,
  Button,
  FormControl,
  FormControlLabel,
  FormLabel,
  Grid,
  Radio,
  RadioGroup,
  TextField,
} from '@mui/material';
import ShareIcon from '@mui/icons-material/Share';
import { Autocomplete } from '@mui/material';
import { toast } from 'react-toastify';
import api from '../../services/api';

export function InfluencerChannel({ partners, formData }) {
  const [partner, setPartner] = useState(null);

  const [experimentName, setExperimentName] = useState(null);

  const [duration, setDuration] = useState(null);
  const [value, setValue] = useState(null);

  const [inviteCodeType, setInviteCodeType] = useState('random');
  const [inviteCode, setInviteCode] = useState('');

  const [generatingInvite, setGeneratingInvite] = useState(false);
  const [inviteUrl, setInviteUrl] = useState(false);

  const handleGeneratePartnerInvite = async () => {
    setInviteUrl(null);

    const body = {
      partner_id: partner.id,
      duration: Number(duration),
      experiment_name: experimentName,
      country_id: formData.selectedCountry,
      budget: Number(value),
      limit: 999999,
      channel: formData.channel,
    };

    if (inviteCode && inviteCodeType === 'custom') {
      if (inviteCode.match(/^[A-Za-z\d]{3,40}$/)) {
        body.token = inviteCode;
      } else {
        toast('O código de convite deve somente contar letras e números entre 3 e 40 caracteres.', { type: 'error' });

        return;
      }
    }

    try {
      setGeneratingInvite(true);
      const response = await api.post('/invite/create', body);

      setInviteUrl(response.data.url);
      setGeneratingInvite(false);
    } catch (error) {
      setGeneratingInvite(false);

      if (error.response?.data?.error) {
        toast(error.response.data.error.message, { type: 'error' });
      } else {
        toast('Ocorreu um erro ao gerar o convite. Tente novamente.', { type: 'error' });
      }
    }
  };

  return (
    <>
      <Grid xs={12} md={12} item>
        <Autocomplete
          options={partners.filter(p => p.type === 'influencer')}
          getOptionLabel={option => option.name}
          getOptionKey={option => option.id}
          onChange={(_e, optionValue) => {
            if (optionValue && optionValue.name) {
              setPartner(optionValue);
            } else {
              setPartner(null);
            }
          }}
          renderInput={params => (
            <TextField style={{ width: '100%' }} {...params} label='Parceiro' variant='outlined' />
          )}
        />
      </Grid>

      <Grid xs={12} md={12} item>
        <TextField
          style={{ width: '100%' }}
          label='Valor'
          variant='outlined'
          type='number'
          value={value}
          onChange={e => {
            setValue(e.target.value);
          }}
        />
      </Grid>

      <Grid xs={12} md={12} item>
        <TextField
          style={{ width: '100%' }}
          label='Nome do experimento'
          variant='outlined'
          onChange={e => {
            setExperimentName(e.target.value);
          }}
        />
      </Grid>

      <Grid xs={12} md={12} item>
        <TextField
          style={{ width: '100%' }}
          label='Duração (dias)'
          variant='outlined'
          type='number'
          onChange={e => {
            setDuration(e.target.value);
          }}
        />
      </Grid>

      <Grid xs={12} md={12} item>
        <FormControl fullWidth component='fieldset'>
          <FormLabel style={{ textAlign: 'left' }} component='legend'>
            Código de convite
          </FormLabel>
          <RadioGroup
            row
            aria-label='inviteCodeType'
            name='inviteCodeType'
            value={inviteCodeType}
            onChange={e => setInviteCodeType(e.target.value)}
          >
            <FormControlLabel value='random' control={<Radio color='primary' />} label='Aleatório' />
            <FormControlLabel value='custom' control={<Radio color='primary' />} label='Customizado' />
          </RadioGroup>
        </FormControl>
      </Grid>

      {inviteCodeType === 'custom' && (
        <Grid xs={12} md={12} item>
          <TextField
            style={{ width: '100%' }}
            onChange={e => {
              setInviteCode(e.target.value);
            }}
            label='Código de convite'
            variant='outlined'
          />
        </Grid>
      )}

      <Box m='auto' mt={3} width='100%' display='flex' justifyContent='center'>
        <Button disabled={generatingInvite} onClick={handleGeneratePartnerInvite} variant='contained' color='primary'>
          {generatingInvite ? 'Gerando...' : 'Gerar'}
        </Button>
      </Box>

      {inviteUrl && (
        <Box m='auto' mt={3}>
          <Button
            onClick={() => {
              navigator.clipboard.writeText(inviteUrl);
            }}
            disabled={generatingInvite}
          >
            <ShareIcon style={{ color: 'blue', fontSize: '36px', cursor: 'pointer' }} />
          </Button>
        </Box>
      )}
    </>
  );
}
